module.exports = __webpack_public_path__ + "img/angular.48ae79d9.svg";